// React imports
import React from 'react';

// React based imports
import { createMuiTheme } from '@material-ui/core/styles';
// Third-party imports

// Project file imports
import Routes from './routes';
import { ThemeProvider } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import { ConfirmProvider } from 'material-ui-confirm';

export default () => {
  const theme = createMuiTheme({
    typography: {
      fontFamily: [
        'Muli',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
    palette: {
      primary: {
        main: '##003C70'
      },
      secondary: {
        main: '#0079E4'
      }
    },
    overrides: {
      MuiPaper: {
        root: {
          boxShadow: 'none !important'
        }
      },
      MUIDataTable: { 
        responsiveBase: {
          overflow: 'unset !important',
        }
      },
      MUIDataTableToolbar: {
        root: {
          display: "none",
        }
      },
      MUIDataTableHeadCell: {
        root: {
          color: '#fff',
          backgroundColor: '#104E84 !important'
        },
        sortActive: {
          color: '#104E84',
          fontWeight: 'bolder',
          backgroundColor: '#fff !important'
        },
        sortAction: {
          alignItems: 'center !important'
        }
      },
      MuiTable: {
        root: {
          borderCollapse: 'separate',
          borderSpacing: '0 6px',
        
        }
      },
      MuiTableCell: {
        root: {
          padding: 10,
          borderBottom: 'none',
        }
      },
      MuiTableRow: {
        root: {
          margin: '10px !important',
        }
      },
      MuiTableSortLabel: {
        icon: {
          color: '#fff !important'
        }
      }
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={4}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        autoHideDuration={3000}
      >
        <ConfirmProvider>
          <Routes />
        </ConfirmProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}